import { render, staticRenderFns } from "./TheDeleteContactGroupModal.vue?vue&type=template&id=1c14707a"
import script from "./TheDeleteContactGroupModal.vue?vue&type=script&lang=js"
export * from "./TheDeleteContactGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports